import { createContext, Dispatch, SetStateAction } from "react";
import { AppMode } from "types/app-mode";

export interface LayoutContext {
    setShowCoverImage?: Dispatch<SetStateAction<boolean>>;
    appMode?: AppMode;
    hasMyBookingBackgroundImage?: boolean;
    isMyBookingBackgroundImageReady?: boolean;
    shouldShowMyBookingBackgroundImage?: boolean;
}
export const LayoutContext = createContext<LayoutContext>({});
